import { Injectable } from '@angular/core';
import { UserData } from '../interfaces/interfaces';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    _userData: UserData|null = null;
    set userData(userData: UserData|null) {
        this._userData = userData;
    }
    get userData(): UserData|null {
        return this._userData;
    }
    get hasGodModePermission(): boolean {
        if (this._userData !== null && this._userData.permissions.includes('godmode')) {
            return true;
        }
        return false;
    }
    get isSuperUser(): boolean {
        return this._userData.id === 0;
    }
    hasPermission(permission: string): boolean {
        if (this.hasGodModePermission || (this._userData !== null && this._userData.permissions.includes(permission))) {
            return true;
        }
        return false;
    }
    hasPermissions(permissions: string[]): boolean {
        if (this.hasGodModePermission) {
            return true;
        }
        return permissions.every(permission => this.hasPermission(permission));
    }
}
